/// Cart ///
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
  const cartDrawerContent = document.getElementById('CartDrawerContent');
  const closeCartDrawerButton = document.getElementById('CloseCartDrawer');
  const cartCountElement = document.getElementById('CartCount');
  const cartType = (window.cartType || (document.getElementById('CartDrawer') ? 'drawer' : 'page'));

  function openCartDrawer() {
    if (cartType !== 'drawer' || !cartDrawer || !cartDrawerOverlay) return;

    const isDesignMode = window.Shopify && Shopify.designMode;

    cartDrawer.classList.add('open');
    cartDrawer.style.right = '0';
    cartDrawer.style.opacity = '1';
    cartDrawer.style.visibility = 'visible';
    cartDrawer.style.display = 'flex';

    if (isDesignMode) {
      cartDrawer.style.zIndex = '999999';
    } else {
      cartDrawer.style.zIndex = '';
    }

    cartDrawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    updateCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawerOverlay) return;

    const isDesignMode = window.Shopify && Shopify.designMode;

    cartDrawer.classList.remove('open');
    cartDrawer.style.right = '-100%';
    cartDrawer.style.opacity = '';
    cartDrawer.style.visibility = '';
    cartDrawer.style.display = '';

    if (isDesignMode) {
      cartDrawer.style.zIndex = '';
    }

    cartDrawerOverlay.classList.remove('active');
    document.body.style.overflow = 'inherit';
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  if (closeCartDrawerButton) {
    closeCartDrawerButton.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  document.addEventListener('click', function (event) {
    if (
      cartDrawer &&
      cartDrawer.classList.contains('open') &&
      !cartDrawer.contains(event.target) &&
      !event.target.closest('a[href*="/cart"]')
    ) {
      closeCartDrawer();
    }
  });

  function updateCartCount(cartItemCount) {
    if (cartCountElement) {
      cartCountElement.textContent = cartItemCount;
    }
  }

  function updateCartDrawerTotal() {
    const totalElement = document.querySelector('#CartDrawerTotal');
    if (!totalElement) return;

    fetch('/cart?view=cart-drawer')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart drawer content');
        }
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const updatedTotal = doc.querySelector('#CartDrawerTotal');
        if (updatedTotal) {
          totalElement.innerHTML = updatedTotal.innerHTML;
        }
      })
      .catch(function (error) {
        console.error('Error updating cart total:', error);
      });
  }

  function removeCartItem(key, removeButton) {
    const cartItem = removeButton.closest('.cart-drawer-item');
    if (cartItem) {
      cartItem.classList.add('fade-out-bck');
    }

    setTimeout(function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Failed to remove item from cart');
          }
          return response.json();
        })
        .then(function (cart) {
          updateCartDrawer();
          updateCartDrawerTotal();
          updateCartCount(cart.item_count);
          // Refresh product page quantity limits
          if (window.fetchCartItems) {
            window.fetchCartItems(function() {
              if (window.updateAllQuantityLimits) window.updateAllQuantityLimits();
            });
          }
        })
        .catch(function (error) {
          console.error('Error removing cart item:', error);
        });
    }, 200);
  }

  function attachRemoveHandlers() {
    document.querySelectorAll('.cart-drawer-item__remove-link').forEach(function (removeButton) {
      if (removeButton.dataset.cartRemoveBound === 'true') return;
      removeButton.dataset.cartRemoveBound = 'true';

      removeButton.addEventListener('click', function (event) {
        event.preventDefault();
        const key = this.dataset.key;
        if (!key) return;
        removeCartItem(key, this);
      });
    });
  }

  function attachQuantityHandlers() {
    document.querySelectorAll('.quantity-wrapper-drawer').forEach(function (wrapper) {
      if (wrapper.dataset.cartQtyBound === 'true') return;
      wrapper.dataset.cartQtyBound = 'true';

      const key = wrapper.dataset.key;
      const inventoryQuantity = parseInt(wrapper.dataset.inventory, 10);
      const trackQuantity = wrapper.dataset.trackQuantity === 'true';
      const allowOversell = wrapper.dataset.allowOversell === 'true';

      const minusButton = wrapper.querySelector('.cart-drawer__quantity-btn-minus');
      const plusButton = wrapper.querySelector('.cart-drawer__quantity-btn-plus');
      const quantityValue = wrapper.querySelector('.cart-drawer__quantity-value');

      if (!key || !quantityValue) return;

      function updateButtonStates() {
        const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;

        if (minusButton) {
          const disableMinus = currentQuantity <= 1;
          minusButton.classList.toggle('disabled', disableMinus);
          minusButton.disabled = disableMinus;
        }

        if (plusButton) {
          if (trackQuantity && !allowOversell) {
            const isMaxQuantity = currentQuantity >= inventoryQuantity;
            plusButton.classList.toggle('disabled', isMaxQuantity);
            plusButton.disabled = isMaxQuantity;
          } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
          }
        }
      }

      function updateCartQuantity(quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Error updating cart');
            }
            return response.json();
          })
          .then(function (cart) {
            quantityValue.textContent = quantity;
            wrapper.dataset.quantity = quantity;
            updateButtonStates();
            updateCartDrawerTotal();
            updateCartCount(cart.item_count);
            // Refresh product page quantity limits
            if (window.fetchCartItems) {
              window.fetchCartItems(function() {
                if (window.updateAllQuantityLimits) window.updateAllQuantityLimits();
              });
            }
          })
          .catch(function (error) {
            console.error('Error updating cart quantity:', error);
          });
      }

      if (minusButton) {
        minusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (currentQuantity > 1) {
            updateCartQuantity(currentQuantity - 1);
          }
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (trackQuantity && !allowOversell && currentQuantity >= inventoryQuantity) {
            alert('Maximum quantity for this product is ' + inventoryQuantity + '.');
          } else {
            updateCartQuantity(currentQuantity + 1);
          }
        });
      }

      updateButtonStates();
    });
  }

  function updateCartDrawer() {
    if (!cartDrawerContent) return;

    fetch('/cart?view=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.getElementById('CartDrawerContent');
        if (newContent) {
          cartDrawerContent.innerHTML = newContent.innerHTML;
          attachRemoveHandlers();
          attachQuantityHandlers();
        }
      })
      .catch(function (error) {
        console.error('Error updating cart drawer:', error);
      });
  }

  function bindCartTriggers(root) {
    if (!root) return;

    root.querySelectorAll('a[href*="/cart"], button[data-cart-drawer-toggle], .js-cart-toggle').forEach(function (cartTrigger) {
      if (cartTrigger.dataset.cartLinkBound === 'true') return;
      cartTrigger.dataset.cartLinkBound = 'true';

      cartTrigger.addEventListener('click', function (event) {
        if (cartType === 'drawer') {
          event.preventDefault();
          openCartDrawer();
        }
      });
    });
  }

  // Helper: compute max addable qty from wrapper data-attrs + cart cache
  function getWrapperMaxQty(wrapper) {
    var management = wrapper.dataset.inventoryManagement;
    var policy = wrapper.dataset.inventoryPolicy;
    if (!management || policy === 'continue') return Infinity;
    var inventoryQty = parseInt(wrapper.dataset.inventoryQuantity, 10) || 0;
    var variantId = wrapper.dataset.variantId;
    var inCart = window.getCartQtyForVariant ? window.getCartQtyForVariant(variantId) : 0;
    return Math.max(0, inventoryQty - inCart);
  }

  // Update plus/minus/value state for all quantity wrappers
  function updateAllQuantityLimits() {
    document.querySelectorAll('.quantity-wrapper-product').forEach(function(wrapper) {
      var plusBtn = wrapper.querySelector('.qty-btn-plus');
      var minusBtn = wrapper.querySelector('.qty-btn-minus');
      var qtyInput = wrapper.querySelector('.qty-value');
      if (!plusBtn || !qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      var maxQty = getWrapperMaxQty(wrapper);

      // Clamp value if it exceeds max
      if (maxQty !== Infinity && val > maxQty) {
        val = Math.max(1, maxQty);
        qtyInput.value = val;
      }

      // Plus button
      if (maxQty !== Infinity && val >= maxQty) {
        plusBtn.classList.add('disabled');
        plusBtn.disabled = true;
      } else {
        plusBtn.classList.remove('disabled');
        plusBtn.disabled = false;
      }

      // Minus button
      if (minusBtn) {
        if (val <= 1) {
          minusBtn.classList.add('disabled');
          minusBtn.disabled = true;
        } else {
          minusBtn.classList.remove('disabled');
          minusBtn.disabled = false;
        }
      }
    });
  }
  window.updateAllQuantityLimits = updateAllQuantityLimits;

  // Product page quantity selector (+/- buttons)
  function initProductQuantity() {
    document.querySelectorAll('.quantity-wrapper-product').forEach(function(wrapper) {
      if (wrapper.dataset.qtyBound === 'true') return;
      wrapper.dataset.qtyBound = 'true';

      var minusBtn = wrapper.querySelector('.qty-btn-minus');
      var plusBtn = wrapper.querySelector('.qty-btn-plus');
      var qtyInput = wrapper.querySelector('.qty-value');
      if (!qtyInput) return;

      function updateButtonStates() {
        var val = parseInt(qtyInput.value, 10) || 1;
        var maxQty = getWrapperMaxQty(wrapper);

        if (minusBtn) {
          if (val <= 1) {
            minusBtn.classList.add('disabled');
            minusBtn.disabled = true;
          } else {
            minusBtn.classList.remove('disabled');
            minusBtn.disabled = false;
          }
        }

        if (plusBtn) {
          if (maxQty !== Infinity && val >= maxQty) {
            plusBtn.classList.add('disabled');
            plusBtn.disabled = true;
          } else {
            plusBtn.classList.remove('disabled');
            plusBtn.disabled = false;
          }
        }
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) {
            qtyInput.value = val - 1;
            updateButtonStates();
          }
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          var maxQty = getWrapperMaxQty(wrapper);
          if (maxQty !== Infinity && val >= maxQty) return;
          qtyInput.value = val + 1;
          updateButtonStates();
        });
      }

      updateButtonStates();
    });
  }

  initProductQuantity();
  window.initProductQuantity = initProductQuantity;

  const addToCartForm = document.getElementById('AddToCartForm');
  if (addToCartForm && !addToCartForm.dataset.cartFormBound) {
    addToCartForm.dataset.cartFormBound = 'true';

    addToCartForm.addEventListener('submit', function (event) {
      event.preventDefault();
      const idInput = addToCartForm.querySelector('input[name="id"]');
      if (!idInput) return;

      const variantId = idInput.value;
      const qtyInput = addToCartForm.querySelector('input[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const submitBtn = addToCartForm.querySelector('.product-info__cart-btn');
      var originalText = '';

      if (submitBtn) {
        originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="btn-loading-dots"><span></span><span></span><span></span></span>';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Error adding to cart');
          }
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (submitBtn) {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }
          // Reset quantity selector to 1
          if (qtyInput) {
            qtyInput.value = 1;
            var minusBtn = addToCartForm.querySelector('.qty-btn-minus');
            if (minusBtn) { minusBtn.classList.add('disabled'); minusBtn.disabled = true; }
          }
          // Refresh cart cache and update quantity limits
          if (window.fetchCartItems) {
            window.fetchCartItems(function() {
              if (window.updateAllQuantityLimits) window.updateAllQuantityLimits();
            });
          }
          if (cartType === 'drawer') {
            openCartDrawer();
          } else if (cartType === 'page') {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error);
          if (submitBtn) {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }
        });
    });
  }

  bindCartTriggers(document);
  attachRemoveHandlers();
  attachQuantityHandlers();

  document.addEventListener('shopify:section:load', function (event) {
    bindCartTriggers(event.target);
    attachRemoveHandlers();
    attachQuantityHandlers();
  });

  // Re-attach handlers when cart content is updated via AJAX (e.g., from featured-product)
  document.addEventListener('cart:updated', function () {
    attachRemoveHandlers();
    attachQuantityHandlers();
  });

  // Sticky add-to-cart bar events
  document.addEventListener('cart:open-drawer', function() {
    openCartDrawer();
  });

  document.addEventListener('cart:item-added', function(e) {
    if (e.detail && e.detail.count !== undefined) {
      updateCartCount(e.detail.count);
    }
    if (window.fetchCartItems) {
      window.fetchCartItems(function() {
        if (window.updateAllQuantityLimits) window.updateAllQuantityLimits();
      });
    }
  });
});


/// Product cards ///
(function () {
  function initOneCard(card) {
    if (!card || card.dataset.productCardBound === 'true') return;
    card.dataset.productCardBound = 'true';

    var imageSwitchEnabled = card.dataset.imageSwitch !== 'false';

    var container = card.querySelector('.product-image-container');
    if (!container) return;

    var link = container.querySelector('a.product-list__img-link');
    if (!link) return;

    var slides = Array.from(link.querySelectorAll('.card-slide'));
    var images = slides.map(function(s) { return s.querySelector('.product-card__image'); });
    if (!slides.length) return;

    // Make sure first slide is active
    slides[0].classList.add('is-active');

    // Hide card-level loader as soon as first image is ready
    var firstImg = images[0];
    if (firstImg) {
      if (firstImg.complete && firstImg.naturalWidth > 0) {
        card.classList.add('loaded');
      } else {
        firstImg.addEventListener('load', function() {
          card.classList.add('loaded');
        }, { once: true });
        firstImg.addEventListener('error', function() {
          card.classList.add('loaded');
        }, { once: true });
      }
    }

    var hasMultiple = slides.length > 1;
    if (!imageSwitchEnabled || !hasMultiple) {
      return;
    }

    var currentIndex = 0;
    var prevBtn = container.querySelector('.product-card-arrow--prev');
    var nextBtn = container.querySelector('.product-card-arrow--next');

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isSquareMode() {
      return card.closest('.product-card-square') !== null;
    }

    function loadLazyImage(img) {
      if (!img || !img.dataset.lazy) return;

      var slide = img.closest('.card-slide');

      function markLoaded() {
        delete img.dataset.lazy;
        if (slide) slide.classList.add('loaded');
        // Also hide card-level loader — any loaded image should dismiss it
        card.classList.add('loaded');
      }

      img.addEventListener('load', markLoaded, { once: true });
      img.addEventListener('error', markLoaded, { once: true });

      // Set sizes before srcset to ensure correct source selection
      if (img.dataset.sizes) { img.sizes = img.dataset.sizes; delete img.dataset.sizes; }
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
      if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }

      // Fallback for cached images where load event may not fire
      if (img.complete && img.naturalWidth > 0) {
        img.removeEventListener('load', markLoaded);
        img.removeEventListener('error', markLoaded);
        markLoaded();
      }
    }

    // Show slide by index — instant switch + preload next
    function showImage(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      currentIndex = idx;

      // Switch instantly
      slides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === idx);
      });

      // Trigger load if lazy
      loadLazyImage(images[idx]);

      // Preload next image
      loadLazyImage(images[(idx + 1) % images.length]);

      // Safety: if image already loaded, ensure slide + card marked loaded
      var curImg = images[idx];
      if (curImg && curImg.complete && curImg.naturalWidth > 0) {
        slides[idx].classList.add('loaded');
        card.classList.add('loaded');
      }
    }

    // Desktop hover — preload all on mouseenter
    container.addEventListener('mouseenter', function() {
      if (isMobile() || !hasMultiple || track) return;
      images.forEach(function(img) { loadLazyImage(img); });
      showImage(1);
    });

    container.addEventListener('mouseleave', function() {
      if (isMobile() || !hasMultiple || track) return;
      showImage(0);
    });

    // Arrow buttons (desktop)
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (track) return;
        showImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (track) return;
        showImage(currentIndex + 1);
      });
    }

    // ========== MOBILE CAROUSEL ==========
    var track = null;
    var mobileIndex = 0;
    var trackWidth = 0;
    var savedLinkHeight = 0;

    function createMobileTrack() {
      if (track) return;

      // Preload all images
      images.forEach(function(img) { loadLazyImage(img); });

      var isSquare = isSquareMode();
      trackWidth = link.offsetWidth || container.offsetWidth || 300;

      // For original mode: save link height before modifying
      if (!isSquare) {
        savedLinkHeight = link.offsetHeight || slides[0].offsetHeight || 300;
      }

      track = document.createElement('div');
      track.className = 'product-card-track';

      // Move slides into track
      slides.forEach(function(slide) {
        slide.classList.remove('is-active');
        if (isSquare) {
          slide.style.cssText = 'position:relative;flex:0 0 ' + trackWidth + 'px;width:' + trackWidth + 'px;height:100%;opacity:1;visibility:visible;overflow:hidden;';
        } else {
          slide.style.cssText = 'position:relative;flex:0 0 ' + trackWidth + 'px;width:' + trackWidth + 'px;height:auto;max-height:' + savedLinkHeight + 'px;opacity:1;visibility:visible;overflow:hidden;';
        }
        track.appendChild(slide);
      });

      // Set track styles
      if (isSquare) {
        track.style.cssText = 'display:flex;position:absolute;top:0;left:0;width:' + (trackWidth * slides.length) + 'px;height:100%;transition:transform 0.3s ease;';
      } else {
        link.style.height = savedLinkHeight + 'px';
        link.style.overflow = 'hidden';
        link.style.position = 'relative';
        track.style.cssText = 'display:flex;position:absolute;top:0;left:0;width:' + (trackWidth * slides.length) + 'px;height:' + savedLinkHeight + 'px;transition:transform 0.3s ease;align-items:center;';
      }

      link.appendChild(track);
      mobileIndex = 0;
      track.style.transform = 'translateX(0)';
    }

    function destroyMobileTrack() {
      if (!track) return;

      var isSquare = isSquareMode();

      // Move slides back
      slides.forEach(function(slide, i) {
        slide.style.cssText = '';
        slide.classList.toggle('is-active', i === 0);
        link.insertBefore(slide, track);
      });

      track.remove();
      track = null;

      // Reset link styles for original mode
      if (!isSquare) {
        link.style.height = '';
        link.style.overflow = '';
      }

      mobileIndex = 0;
      currentIndex = 0;
    }

    function snapToIndex(idx) {
      if (!track) return;
      idx = Math.max(0, Math.min(idx, slides.length - 1));
      mobileIndex = idx;
      currentIndex = idx;
      track.style.transition = 'transform 0.3s ease';
      track.style.transform = 'translateX(' + (-idx * trackWidth) + 'px)';
    }

    // Touch handling
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDx = 0;
    var isDragging = false;
    var isHorizontal = false;

    container.addEventListener('touchstart', function(e) {
      if (!isMobile() || !hasMultiple) return;
      if (!e.touches || !e.touches[0]) return;

      if (!track) createMobileTrack();

      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDx = 0;
      isDragging = true;
      isHorizontal = false;

      if (track) {
        trackWidth = link.offsetWidth || container.offsetWidth || 300;
        track.style.transition = 'none';
      }
    }, { passive: true });

    container.addEventListener('touchmove', function(e) {
      if (!isMobile() || !isDragging || !track) return;
      if (!e.touches || !e.touches[0]) return;

      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      if (!isHorizontal && Math.abs(dx) < 10 && Math.abs(dy) < 10) return;

      if (!isHorizontal) {
        if (Math.abs(dx) > Math.abs(dy)) {
          isHorizontal = true;
        } else {
          isDragging = false;
          return;
        }
      }

      e.preventDefault();
      touchDx = dx;
      var base = -mobileIndex * trackWidth;
      track.style.transform = 'translateX(' + (base + touchDx) + 'px)';
    }, { passive: false });

    container.addEventListener('touchend', function() {
      if (!isMobile() || !track) return;
      isDragging = false;

      if (!isHorizontal) return;

      var threshold = trackWidth * 0.2;
      if (touchDx < -threshold && mobileIndex < slides.length - 1) {
        snapToIndex(mobileIndex + 1);
      } else if (touchDx > threshold && mobileIndex > 0) {
        snapToIndex(mobileIndex - 1);
      } else {
        snapToIndex(mobileIndex);
      }
    }, { passive: true });

    // Handle resize / mode change
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function handleModeChange() {
      if (!isMobile()) {
        destroyMobileTrack();
      }
    }

    function handleResize() {
      if (!track || !isMobile()) return;

      var isSquare = isSquareMode();
      var newWidth = link.offsetWidth || container.offsetWidth || 300;

      slides.forEach(function(slide) {
        slide.style.flex = '0 0 ' + newWidth + 'px';
        slide.style.width = newWidth + 'px';
      });

      track.style.width = (newWidth * slides.length) + 'px';
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-mobileIndex * newWidth) + 'px)';

      trackWidth = newWidth;
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleModeChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(handleModeChange);
    }

    window.addEventListener('resize', function() {
      clearTimeout(card._resizeTimer);
      card._resizeTimer = setTimeout(handleResize, 100);
    });

    if (!isMobile() && track) {
      destroyMobileTrack();
    }
  }

  function initAll(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-product-card]');
    cards.forEach(function (card) {
      initOneCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);

    var grid =
      document.querySelector('#CollectionProductGrid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.collection-grid') ||
      document.querySelector('.product-list') ||
      document.body;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-card]')) {
            initOneCard(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Expose globally for infinity scroll
  window.initOneCard = initOneCard;
})();


/// Background Lazy Image Preloader ///
(function() {
  function preloadLazyImages() {
    var lazyImages = document.querySelectorAll('img[data-lazy="true"]');
    if (!lazyImages.length) return;

    var delay = 100; // ms between each image load
    lazyImages.forEach(function(img, index) {
      setTimeout(function() {
        if (!img.dataset.lazy) return; // Already loaded by user interaction

        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          delete img.dataset.srcset;
        }
        if (img.dataset.sizes) {
          img.sizes = img.dataset.sizes;
          delete img.dataset.sizes;
        }
        if (img.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }
        delete img.dataset.lazy;
      }, index * delay);
    });
  }

  // Start preloading 2 seconds after page load
  window.addEventListener('load', function() {
    setTimeout(preloadLazyImages, 2000);
  });
})();


/// Footer Big Logo Fit ///
(function () {
  function fitFooterBigLogoText(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll('.footer__big-logo-text');
    if (!elements.length) return;

    elements.forEach(function (el) {
      var cropWrap = el.closest('.footer__big-logo-crop');
      var fitWrap = el.closest('.footer__big-logo-fit');
      if (!cropWrap || !fitWrap) return;

      // Check if element is visible
      if (el.offsetParent === null && getComputedStyle(el).display === 'none') return;

      el.style.setProperty('--fit', 1);
      cropWrap.style.removeProperty('--cropH');

      var wrapW = fitWrap.getBoundingClientRect().width;
      var textW = el.scrollWidth;

      // If dimensions are 0, retry after a short delay
      if (!wrapW || !textW) {
        setTimeout(function() { fitFooterBigLogoText(root); }, 100);
        return;
      }

      var s = wrapW / textW;
      el.style.setProperty('--fit', s);

      requestAnimationFrame(function () {
        var scaledH = el.getBoundingClientRect().height;
        var cropPercent = parseFloat(getComputedStyle(cropWrap).getPropertyValue('--crop')) || 0;

        var cropPx = scaledH * (cropPercent / 100);
        var finalH = Math.max(0, scaledH - cropPx);

        cropWrap.style.setProperty('--cropH', finalH + 'px');
        el.style.setProperty('--cropShift', cropPx + 'px');
      });
    });
  }

  // Make function globally accessible for manual calls
  window.fitFooterBigLogoText = fitFooterBigLogoText;

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    fitFooterBigLogoText(document);
  });

  // Also run on window load as fallback (fonts may not be loaded on DOMContentLoaded)
  window.addEventListener('load', function () {
    fitFooterBigLogoText(document);
  });

  // Run immediately if DOM is already loaded
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() { fitFooterBigLogoText(document); }, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    fitFooterBigLogoText(e.target);
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.__fitFooterLogoT);
    window.__fitFooterLogoT = setTimeout(function () {
      fitFooterBigLogoText(document);
    }, 80);
  });
})();

/// Image Banner #3 Text Fit ///
(function () {
  function fitBanner3Text(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll('[data-banner3-text]');
    if (!elements.length) return;

    elements.forEach(function (el) {
      var sectionId = el.getAttribute('data-banner3-text');
      var cropWrap = el.closest('.bg-text-crop');
      var fitWrap = el.closest('.bg-text-fit');
      if (!cropWrap || !fitWrap) return;

      // Check if element is visible
      if (el.offsetParent === null && getComputedStyle(el).display === 'none') return;

      el.style.setProperty('--fit-' + sectionId, 1);
      cropWrap.style.removeProperty('--cropH-' + sectionId);

      var wrapW = fitWrap.getBoundingClientRect().width;
      var textW = el.scrollWidth;

      // If dimensions are 0, retry after a short delay
      if (!wrapW || !textW) {
        setTimeout(function() { fitBanner3Text(root); }, 100);
        return;
      }

      var s = wrapW / textW;
      el.style.setProperty('--fit-' + sectionId, s);

      requestAnimationFrame(function () {
        var scaledH = el.getBoundingClientRect().height;
        var cropPercent = parseFloat(getComputedStyle(cropWrap).getPropertyValue('--crop-' + sectionId)) || 0;

        var cropPx = scaledH * (cropPercent / 100);
        var finalH = Math.max(0, scaledH - cropPx);

        cropWrap.style.setProperty('--cropH-' + sectionId, finalH + 'px');
        el.style.setProperty('--cropShift-' + sectionId, cropPx + 'px');
      });
    });
  }

  window.fitBanner3Text = fitBanner3Text;

  document.addEventListener('DOMContentLoaded', function () {
    fitBanner3Text(document);
  });

  window.addEventListener('load', function () {
    fitBanner3Text(document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() { fitBanner3Text(document); }, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    fitBanner3Text(e.target);
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.__fitBanner3T);
    window.__fitBanner3T = setTimeout(function () {
      fitBanner3Text(document);
    }, 80);
  });
})();

/// Page Loader ///
(function () {
  var loader = document.getElementById('pageloader');
  if (!loader) return;

  var active = false;
  var MIN_DISPLAY = 600; // minimum ms the preloader stays visible
  // Use navigation start time (when preloader actually appeared), not JS execution time
  var showTime = (typeof performance !== 'undefined')
    ? (performance.timeOrigin || (performance.timing && performance.timing.navigationStart) || Date.now())
    : Date.now();

  function show(noAnim) {
    if (active) return;
    active = true;
    showTime = Date.now();

    if (noAnim) loader.classList.add('no-anim');
    loader.classList.add('show');

    if (noAnim) {
      requestAnimationFrame(function () {
        loader.classList.remove('no-anim');
      });
    }
  }

  function hide() {
    loader.classList.remove('show');
    active = false;

    document.documentElement.classList.remove('pageloader-hide-body');
    document.documentElement.classList.remove('pageloader-force-show');
  }

  // Hide preloader once DOM is ready, respecting minimum display time
  function hideWhenReady() {
    loader.classList.remove('no-anim');
    var elapsed = Date.now() - showTime;
    var delay = Math.max(0, MIN_DISPLAY - elapsed);

    setTimeout(function () {
      requestAnimationFrame(function () {
        hide();
      });
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideWhenReady);
  } else {
    hideWhenReady();
  }

  // Only handle bfcache restore (back/forward navigation)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) hide();
  });

  function samePage(href) {
    try {
      var u = new URL(href, location.href);
      return u.pathname === location.pathname && u.search === location.search;
    } catch (e) {
      return true;
    }
  }

function shouldHandle(a, e) {
  if (!a || e.defaultPrevented) return false;
  if (a.classList && a.classList.contains('js-cart-toggle')) return false;
  if (a.closest && a.closest('.js-cart-toggle')) return false;

  // Exclude Shopify app elements - don't intercept their clicks
  if (a.closest && (
    a.closest('[data-app-block-id]') ||
    a.closest('[data-shopify-app]') ||
    a.closest('.shopify-app-block') ||
    a.closest('.shopify-block') ||
    a.closest('[data-shopify]') ||
    a.closest('.spr-') ||
    a.closest('[class*="judgeme"]') ||
    a.closest('[class*="loox"]') ||
    a.closest('[class*="stamped"]') ||
    a.closest('[class*="yotpo"]') ||
    a.closest('[class*="klaviyo"]') ||
    a.closest('[class*="privy"]') ||
    a.closest('[class*="omnisend"]')
  )) return false;

  // External links, new tabs, downloads — page stays, don't show loader
  if (a.target && a.target !== '_self') return false;
  if (a.hasAttribute('download')) return false;

  const href = a.getAttribute('href');
  if (!href) return false;

  if (
    href === '#' ||
    href === '' ||
    href.startsWith('javascript:') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  ) {
    return false;
  }

  if (href.indexOf('/cart') !== -1 && document.getElementById('CartDrawer')) return false;

  if (href.startsWith('#')) return false;

  if (
    a.closest('.menu-item') &&
    a.parentElement.querySelector('.submenu, .dropdown, .sub-menu')
  ) {
    return false;
  }

  try {
    const u = new URL(href, location.href);
    if (u.pathname === location.pathname && u.search === location.search) {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
}



  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!shouldHandle(a, e)) return;

      e.preventDefault();
      show(true);

      // Safety: if navigation doesn't happen (same page, broken link, etc.), hide after 5s
      setTimeout(function () {
        if (active) hide();
      }, 5000);

      setTimeout(function () {
        location.href = a.href;
      }, 60);
    },
    false
  );

})();

/// Horizontal Scroll Slider (Photo Carousel, Featured Collection Slider, etc.) ///
(function () {
  function initScrollSlider(wrapper) {
    if (!wrapper || wrapper.dataset.scrollSliderBound === 'true') return;
    wrapper.dataset.scrollSliderBound = 'true';

    var carousel = wrapper.querySelector('.scroll-slider-track');
    var slider = wrapper.querySelector('.scroll-slider-progress');
    var sliderWrapper = wrapper.querySelector('.scroll-slider-bar');

    if (!carousel) return;

    var isDragging = false;
    var hasDragged = false;
    var startX;
    var scrollLeft;
    var dragThreshold = 5;

    function updateSlider() {
      if (!slider || !sliderWrapper) return;

      var maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;

      // Hide scroll bar if nothing to scroll
      if (maxScrollLeft <= 0) {
        sliderWrapper.style.display = 'none';
        return;
      } else {
        sliderWrapper.style.display = '';
      }

      var scrollPosition = carousel.scrollLeft;
      var sliderWidth = (carousel.clientWidth / carousel.scrollWidth) * sliderWrapper.clientWidth;
      var maxSliderLeft = sliderWrapper.clientWidth - sliderWidth;
      var sliderLeft = (scrollPosition / maxScrollLeft) * maxSliderLeft;

      slider.style.width = sliderWidth + 'px';
      slider.style.left = sliderLeft + 'px';
    }

    // Prevent default drag behavior for images and links
    var images = wrapper.querySelectorAll('img');
    images.forEach(function (img) {
      img.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });

    var links = carousel.querySelectorAll('a');
    links.forEach(function (link) {
      link.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      link.style.userSelect = 'none';
      link.style.webkitUserSelect = 'none';
    });

    // Prevent click on links if user was dragging
    carousel.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    // Disable selection on carousel
    carousel.style.userSelect = 'none';
    carousel.style.webkitUserSelect = 'none';

    // Mouse drag functionality
    carousel.addEventListener('mousedown', function (e) {
      isDragging = true;
      hasDragged = false;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      carousel.style.scrollBehavior = 'auto';
      carousel.classList.add('dragging');
    });

    carousel.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var x = e.pageX - carousel.offsetLeft;
      var walk = x - startX;

      // Only mark as dragged if moved more than threshold
      if (Math.abs(walk) > dragThreshold) {
        hasDragged = true;
      }

      carousel.scrollLeft = scrollLeft - walk;
    });

    carousel.addEventListener('mouseup', function () {
      isDragging = false;
      carousel.style.scrollBehavior = '';
      carousel.classList.remove('dragging');
    });

    carousel.addEventListener('mouseleave', function () {
      isDragging = false;
      carousel.style.scrollBehavior = '';
      carousel.classList.remove('dragging');
    });

    // Update slider on scroll
    carousel.addEventListener('scroll', updateSlider);

    // Initialize slider position
    updateSlider();

    // Update on image load
    images.forEach(function (img) {
      img.addEventListener('load', updateSlider);
      img.addEventListener('error', updateSlider);
    });

    // Update on resize
    window.addEventListener('resize', function () {
      clearTimeout(wrapper.__sliderResizeT);
      wrapper.__sliderResizeT = setTimeout(updateSlider, 100);
    });
  }

  function initAllScrollSliders(root) {
    var scope = root || document;
    var wrappers = scope.querySelectorAll('[data-scroll-slider]');
    wrappers.forEach(function (wrapper) {
      initScrollSlider(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllScrollSliders(document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function () { initAllScrollSliders(document); }, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    // Reset bound flag for re-initialization
    var wrappers = e.target.querySelectorAll('[data-scroll-slider]');
    wrappers.forEach(function (w) { w.dataset.scrollSliderBound = 'false'; });
    initAllScrollSliders(e.target);
  });

  window.initScrollSlider = initScrollSlider;
  window.initAllScrollSliders = initAllScrollSliders;
})();

/// Header Scroll Behavior ///
(function () {
  var scrollHandler = null;
  var resizeHandler = null;

  // Calculate and set CSS variables for header heights
  function calculateHeaderHeights() {
    var root = document.documentElement;
    var headerSection = document.querySelector('.header-section');

    // Try to find header group wrapper first (our customizer uses this)
    var headerGroupWrapper = document.querySelector('.shopify-section-group-header-group:has(.shopify-section)')
      || document.querySelector('#shopify-section-group-header-group');

    var headerGroupHeight = 0;

    if (headerGroupWrapper && headerGroupWrapper.querySelector('.shopify-section')) {
      // We have a wrapper containing sections (our customizer format)
      headerGroupHeight = headerGroupWrapper.offsetHeight || 0;
    } else {
      // Shopify format: each section has the class, no wrapper
      // Sum heights of all sections with this class
      var headerGroupSections = document.querySelectorAll('.shopify-section.shopify-section-group-header-group');
      if (headerGroupSections.length > 0) {
        headerGroupSections.forEach(function(section) {
          headerGroupHeight += section.offsetHeight || 0;
        });
      }
    }

    // Fallback to just header section if nothing found
    if (headerGroupHeight === 0 && headerSection) {
      headerGroupHeight = headerSection.offsetHeight || 60;
    }

    root.style.setProperty('--header-group-height', headerGroupHeight + 'px');

    return { headerGroupHeight: headerGroupHeight };
  }

  window.calculateHeaderHeights = calculateHeaderHeights;

  function initHeaderScroll() {
    var headerSection = document.querySelector('.header-section');
    // Try to find header group wrapper (our customizer) or individual sections (Shopify)
    var headerGroupWrapper = document.querySelector('.shopify-section-group-header-group:has(.shopify-section)')
      || document.querySelector('#shopify-section-group-header-group');
    var headerGroupSections = document.querySelectorAll('.shopify-section.shopify-section-group-header-group');
    var headerGroupSpacer = document.getElementById('headerGroupSpacer');

    // Determine if we have a wrapper or individual sections
    var hasWrapper = headerGroupWrapper && headerGroupWrapper.querySelector('.shopify-section');
    var headerGroupElements = hasWrapper ? [headerGroupWrapper] : Array.from(headerGroupSections);

    if (!headerSection || headerGroupElements.length === 0) return;

    // Helper to add/remove class from all header group elements
    function addClassToHeaderGroup(className) {
      headerGroupElements.forEach(function(el) { el.classList.add(className); });
    }
    function removeClassFromHeaderGroup(className) {
      headerGroupElements.forEach(function(el) { el.classList.remove(className); });
    }

    // Clean up previous handlers
    if (scrollHandler) window.removeEventListener('scroll', scrollHandler);
    if (resizeHandler) window.removeEventListener('resize', resizeHandler);

    var headerBehavior = headerSection.getAttribute('data-header-behavior') || 'static';
    var isOverlayMode = headerSection.getAttribute('data-overlay-mode') === 'true';

    // Reset classes and offsets
    removeClassFromHeaderGroup('header-group--fixed');
    removeClassFromHeaderGroup('header-group--overlay');
    removeClassFromHeaderGroup('header-hidden');
    // Reset section top offsets
    headerGroupElements.forEach(function(el) { el.style.removeProperty('--section-top-offset'); });
    if (headerGroupSpacer) headerGroupSpacer.classList.remove('is-active');

    // Calculate heights
    var heights = calculateHeaderHeights();

    // Static mode - no fixing needed
    if (headerBehavior === 'static') {
      window.dispatchEvent(new CustomEvent('headerHeightReady'));
      return;
    }

    // Fixed/Sticky mode - fix the entire header-group (same for overlay and non-overlay)
    addClassToHeaderGroup('header-group--fixed');

    // For Shopify format (no wrapper), set top offset for each section
    if (!hasWrapper && headerGroupSections.length > 1) {
      var cumulativeTop = 0;
      headerGroupSections.forEach(function(section) {
        section.style.setProperty('--section-top-offset', cumulativeTop + 'px');
        cumulativeTop += section.offsetHeight || 0;
      });
    }

    // Setup spacer
    if (headerGroupSpacer) {
      if (isOverlayMode) {
        // Overlay: no spacer - content goes under transparent header
        headerGroupSpacer.classList.remove('is-active');
        headerGroupSpacer.style.height = '0px';
      } else {
        // Normal: spacer = full header-group height
        headerGroupSpacer.classList.add('is-active');
        headerGroupSpacer.style.height = heights.headerGroupHeight + 'px';
      }
    }

    var lastY = 0;
    var isHidden = false;

    function handleScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      var scrollingDown = y > lastY;
      var scrollingUp = y < lastY;

      // Sticky: hide entire header-group on scroll down, show on scroll up
      if (headerBehavior === 'sticky') {
        var heroLogoActive = headerSection.classList.contains('hero-logo-active') &&
                            headerSection.classList.contains('in-banner-area');

        if (y <= 10 || heroLogoActive) {
          if (isHidden) {
            isHidden = false;
            removeClassFromHeaderGroup('header-hidden');
          }
        } else if (scrollingDown && y > 50 && !isHidden) {
          isHidden = true;
          addClassToHeaderGroup('header-hidden');
        } else if (scrollingUp && isHidden) {
          isHidden = false;
          removeClassFromHeaderGroup('header-hidden');
        }
      }

      // Overlay mode: toggle background transparency
      if (isOverlayMode) {
        var heroLogoInBanner = headerSection.classList.contains('hero-logo-active') &&
                               headerSection.classList.contains('in-banner-area');

        if (heroLogoInBanner || y <= 50) {
          headerSection.classList.remove('header-scrolled');
        } else {
          headerSection.classList.add('header-scrolled');
        }
      }

      lastY = y;
    }

    scrollHandler = handleScroll;
    window.addEventListener('scroll', scrollHandler, { passive: true });

    resizeHandler = function() {
      var newHeights = calculateHeaderHeights();
      sectionsBeforeHeight = newHeights.sectionsBeforeHeight;
      if (headerGroupSpacer && !isOverlayMode) {
        headerGroupSpacer.style.height = newHeights.headerGroupHeight + 'px';
      }
      // Recalculate section top offsets for Shopify format
      if (!hasWrapper && headerGroupSections.length > 1) {
        var cumulativeTop = 0;
        headerGroupSections.forEach(function(section) {
          section.style.setProperty('--section-top-offset', cumulativeTop + 'px');
          cumulativeTop += section.offsetHeight || 0;
        });
      }
      // Re-run scroll handler to update positions
      handleScroll();
    };
    window.addEventListener('resize', resizeHandler);

    // Initial scroll check
    handleScroll();
    window.dispatchEvent(new CustomEvent('headerHeightReady'));
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      calculateHeaderHeights();
      initHeaderScroll();
    });
  } else {
    calculateHeaderHeights();
    initHeaderScroll();
  }

  // Customizer support
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      calculateHeaderHeights();
      initHeaderScroll();
    }, 100);
  });

  document.addEventListener('shopify:section:unload', function() {
    setTimeout(function() {
      calculateHeaderHeights();
      initHeaderScroll();
    }, 100);
  });

  // Expose recalculate function globally for customize-panel to call after updates
  window.recalculateHeaderHeights = function() {
    calculateHeaderHeights();
    initHeaderScroll();
  };
})();

/// Circular Text ///
(function () {
  function initCircularText(container) {
    var textPaths = container.querySelectorAll('.circular-text textPath[id^="textPath-"]');

    textPaths.forEach(function(textPath) {
      if (textPath.dataset.initialized === 'true') return;
      textPath.dataset.initialized = 'true';

      var pathId = textPath.getAttribute('href') || textPath.getAttribute('xlink:href');
      if (!pathId) return;

      var path = container.querySelector(pathId);
      if (!path) return;

      var baseText = textPath.dataset.text;
      if (!baseText) return;

      var separator = ' • ';
      var segment = baseText + separator;

      // Get path length
      var pathLength = path.getTotalLength();

      // Create temp SVG to measure text
      var tempSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      tempSvg.style.position = 'absolute';
      tempSvg.style.visibility = 'hidden';
      var tempText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      var styles = window.getComputedStyle(textPath);
      tempText.style.fontSize = styles.fontSize;
      tempText.style.fontFamily = styles.fontFamily;
      tempText.textContent = segment;
      tempSvg.appendChild(tempText);
      document.body.appendChild(tempSvg);

      var segmentLength = tempText.getComputedTextLength();
      document.body.removeChild(tempSvg);

      // Calculate how many complete segments fit
      var repetitions = Math.max(Math.floor(pathLength / segmentLength), 1);

      // Calculate the text content
      var fullText = '';
      for (var i = 0; i < repetitions; i++) {
        fullText += segment;
      }
      var charCount = fullText.length;

      // Calculate total text length without extra spacing
      tempText.textContent = fullText;
      tempSvg.appendChild(tempText);
      document.body.appendChild(tempSvg);
      var totalTextLength = tempText.getComputedTextLength();
      document.body.removeChild(tempSvg);

      // Calculate letter-spacing to fill the gap
      var gap = pathLength - totalTextLength;
      var letterSpacing = gap / charCount;

      // Apply the text and calculated letter-spacing
      textPath.textContent = fullText;
      textPath.style.letterSpacing = Math.max(letterSpacing, 0) + 'px';
    });
  }

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    initCircularText(document);
  });

  // Run immediately if DOM is already loaded
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() { initCircularText(document); }, 50);
  }

  // Run on section load (Shopify theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    // Reset initialized flag so it re-calculates
    var textPaths = section.querySelectorAll('.circular-text textPath[id^="textPath-"]');
    textPaths.forEach(function(tp) { tp.dataset.initialized = 'false'; });
    initCircularText(section);
  });

  // Expose globally for manual calls
  window.initCircularText = initCircularText;
})();

/// Collection Filtering & Sorting (Native/Server-side) ///
(function () {
  function initCollectionSection(section) {
    if (!section || section.dataset.collectionBound === 'true') return;
    section.dataset.collectionBound = 'true';

    // Elements
    var drawer = section.querySelector('[data-filter-drawer]');
    var overlay = section.querySelector('[data-drawer-overlay]');
    var openBtns = section.querySelectorAll('[data-open-drawer]');
    var closeBtns = section.querySelectorAll('[data-close-drawer]');

    // Drawer functions
    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openDrawer); });
    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Price range sliders - sync with number inputs
    var priceSliders = section.querySelectorAll('[data-price]');
    var priceInputs = section.querySelectorAll('[data-price-input]');

    function updatePriceProgress() {
      var sliderContainers = section.querySelectorAll('[data-price-slider]');
      sliderContainers.forEach(function(container) {
        var minSlider = container.querySelector('[data-price="min"]');
        var maxSlider = container.querySelector('[data-price="max"]');
        var progress = container.querySelector('.price-range-progress');

        if (minSlider && maxSlider && progress) {
          var min = parseFloat(minSlider.value);
          var max = parseFloat(maxSlider.value);
          var rangeMin = parseFloat(minSlider.min);
          var rangeMax = parseFloat(minSlider.max);
          var range = rangeMax - rangeMin;

          if (range > 0) {
            progress.style.left = ((min - rangeMin) / range * 100) + '%';
            progress.style.width = ((max - min) / range * 100) + '%';
          }
        }
      });
    }

    // Initialize price sliders - values are already set in Liquid (in dollars)
    // Just update the progress bar
    updatePriceProgress();

    priceSliders.forEach(function(slider) {
      slider.addEventListener('input', function(e) {
        var type = e.target.dataset.price;
        var value = Math.round(parseFloat(e.target.value));
        var container = e.target.closest('[data-price-slider]');
        var form = e.target.closest('form');

        // Get the other slider to enforce min <= max
        var otherType = type === 'min' ? 'max' : 'min';
        var otherSlider = container ? container.querySelector('[data-price="' + otherType + '"]') : null;

        if (otherSlider) {
          var otherValue = Math.round(parseFloat(otherSlider.value));
          if (type === 'min' && value > otherValue) {
            value = otherValue;
            e.target.value = value;
          } else if (type === 'max' && value < otherValue) {
            value = otherValue;
            e.target.value = value;
          }
        }

        // Sync the corresponding number input and hidden input in the same form
        if (form) {
          var input = form.querySelector('[data-price-input="' + type + '"]');
          if (input) input.value = value;
          // Sync the visible input (no hidden input needed - Dawn approach)
          // Shopify expects dollars directly, not cents
        }

        updatePriceProgress();
      });
    });

    priceInputs.forEach(function(input) {
      input.addEventListener('change', function(e) {
        var type = e.target.dataset.priceInput;
        var value = Math.round(parseFloat(e.target.value)) || 0;
        var form = e.target.closest('form');
        var container = form ? form.querySelector('[data-price-slider]') : null;

        // Clamp value to min/max range
        var min = Math.round(parseFloat(e.target.min)) || 0;
        var max = Math.round(parseFloat(e.target.max)) || 999999;
        value = Math.max(min, Math.min(max, value));
        e.target.value = value;

        // Sync the corresponding range slider in the same form
        if (container) {
          var slider = container.querySelector('[data-price="' + type + '"]');
          if (slider) slider.value = value;
        }

        // No hidden input needed - Dawn approach submits dollars directly

        updatePriceProgress();
      });
    });

    // Clean up default price values before form submit (to avoid unnecessary URL params)
    var filterForms = section.querySelectorAll('[data-filter-form]');
    filterForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var minInput = form.querySelector('[data-price-input="min"]');
        var maxInput = form.querySelector('[data-price-input="max"]');
        var slider = form.querySelector('[data-price-slider]');

        if (minInput && maxInput && slider) {
          var rangeMax = parseFloat(slider.dataset.max) || 0;
          var minVal = parseFloat(minInput.value) || 0;
          var maxVal = parseFloat(maxInput.value) || rangeMax;

          // If both values are at defaults (0 and max), remove them from submission
          if (minVal === 0 && maxVal === rangeMax) {
            minInput.removeAttribute('name');
            maxInput.removeAttribute('name');
          }
          // If only min is at default, keep max but remove min
          else if (minVal === 0) {
            minInput.removeAttribute('name');
          }
          // If only max is at default, keep min but remove max
          else if (maxVal === rangeMax) {
            maxInput.removeAttribute('name');
          }
        }
      });
    });

    // Sync topbar sort select with sidebar hidden input
    var topbarSortSelect = section.querySelector('[data-sort-select]');
    var sidebarSortHidden = section.querySelector('[data-sort-hidden]');
    var topbarForm = document.getElementById('filter-form-topbar');

    if (topbarSortSelect && topbarForm) {
      topbarSortSelect.addEventListener('change', function(e) {
        // Update the hidden input in the topbar form
        var hiddenInput = topbarForm.querySelector('input[name="sort_by"]');
        if (hiddenInput) hiddenInput.value = e.target.value;

        // Also update the sidebar hidden input if it exists
        if (sidebarSortHidden) sidebarSortHidden.value = e.target.value;

        // Submit the topbar form
        topbarForm.submit();
      });
    }

    // Initialize price progress bars
    updatePriceProgress();
  }

  function initAllCollectionSections(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-collection-section]');
    sections.forEach(function(section) {
      initCollectionSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllCollectionSections(document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() { initAllCollectionSections(document); }, 50);
  }

  document.addEventListener('shopify:section:load', function(e) {
    // Reset bound flag for re-initialization
    var sections = e.target.querySelectorAll('[data-collection-section]');
    sections.forEach(function(s) { s.dataset.collectionBound = 'false'; });
    initAllCollectionSections(e.target);
  });

  window.initCollectionSection = initCollectionSection;
  window.initAllCollectionSections = initAllCollectionSections;
})();

/// Infinity Scroll for Collection Pages ///
(function () {
  function initInfinityScroll() {
    var paginationData = document.getElementById('pagination-data');
    if (!paginationData) return;

    var productsContainer = document.querySelector('[data-products-container]');
    var loadingLogo = document.getElementById('loading-logo');
    var collectionSection = document.querySelector('[data-collection-section]');

    if (!productsContainer || !collectionSection) return;

    var currentPage = parseInt(paginationData.dataset.currentPage, 10) || 1;
    var maxPages = parseInt(paginationData.dataset.maxPages, 10) || 1;
    var collectionUrl = collectionSection.dataset.collectionUrl || window.location.pathname;
    var isLoading = false;

    // Get current URL params (for filters/sorting)
    function getUrlParams() {
      var params = new URLSearchParams(window.location.search);
      return params.toString();
    }

    function showLoading() {
      if (loadingLogo) loadingLogo.style.display = 'block';
    }

    function hideLoading() {
      if (loadingLogo) loadingLogo.style.display = 'none';
    }

    function loadNextPage() {
      if (isLoading || currentPage >= maxPages) return;

      isLoading = true;
      showLoading();

      var nextPage = currentPage + 1;
      var urlParams = getUrlParams();
      var fetchUrl = collectionUrl + '?page=' + nextPage + (urlParams ? '&' + urlParams : '');

      fetch(fetchUrl)
        .then(function(response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newProducts = doc.querySelector('[data-products-container]');

          if (newProducts && newProducts.children.length > 0) {
            // Append new products
            var fragment = document.createDocumentFragment();
            Array.from(newProducts.children).forEach(function(product) {
              fragment.appendChild(product.cloneNode(true));
            });
            productsContainer.appendChild(fragment);

            // Initialize new product cards
            var newCards = productsContainer.querySelectorAll('[data-product-card]:not([data-product-card-bound])');
            newCards.forEach(function(card) {
              if (typeof window.initOneCard === 'function') {
                window.initOneCard(card);
              }
            });

            currentPage = nextPage;
            paginationData.dataset.currentPage = currentPage;
          }

          hideLoading();
          isLoading = false;
        })
        .catch(function(error) {
          console.error('Infinity scroll error:', error);
          hideLoading();
          isLoading = false;
        });
    }

    function handleScroll() {
      if (isLoading || currentPage >= maxPages) return;

      var scrollPosition = window.scrollY + window.innerHeight;
      var documentHeight = document.documentElement.scrollHeight;
      var threshold = 500; // Load when 500px from bottom

      if (scrollPosition >= documentHeight - threshold) {
        loadNextPage();
      }
    }

    // Throttle scroll handler
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(function() {
        scrollTimeout = null;
        handleScroll();
      }, 100);
    }, { passive: true });

    // Initial check in case page is short
    setTimeout(handleScroll, 500);
  }

  document.addEventListener('DOMContentLoaded', initInfinityScroll);

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-collection-section]')) {
      setTimeout(initInfinityScroll, 100);
    }
  });
})();

/// Announcement Bar Marquee ///
(function() {
  function initMarquee(container) {
    var wrapper = container.querySelector('.announcement-marquee-wrapper');
    var marquee = container.querySelector('.announcement-marquee');
    var content = container.querySelector('[data-marquee-content]');

    if (!wrapper || !marquee || !content) return;

    // Cancel any existing JS animation
    if (marquee._marqueeRaf) {
      cancelAnimationFrame(marquee._marqueeRaf);
      marquee._marqueeRaf = null;
    }

    // Remove existing clones
    var clones = marquee.querySelectorAll('.marquee-clone');
    clones.forEach(function(clone) { clone.remove(); });

    // Reset — no CSS animation, JS drives it
    marquee.classList.remove('animate');
    marquee.style.transform = '';

    // Wait for fonts and layout
    requestAnimationFrame(function() {
      var wrapperWidth = wrapper.offsetWidth;
      var contentWidth = content.offsetWidth;

      if (contentWidth === 0) {
        setTimeout(function() { initMarquee(container); }, 100);
        return;
      }

      // Step 1: Calculate how many items needed to fill wrapper once
      var itemsToFill = Math.ceil(wrapperWidth / contentWidth) + 1;

      // Step 2: Create first set of clones to fill the wrapper
      for (var i = 0; i < itemsToFill; i++) {
        var clone = content.cloneNode(true);
        clone.classList.add('marquee-clone');
        clone.removeAttribute('data-marquee-content');
        marquee.appendChild(clone);
      }

      // Step 3: Get width of first half (original + first set of clones)
      var firstHalfWidth = marquee.scrollWidth;

      // Step 4: Duplicate EVERYTHING to create identical second half
      var allItems = marquee.querySelectorAll('.announcement-marquee-item');
      allItems.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.classList.add('marquee-clone', 'marquee-second-half');
        clone.removeAttribute('data-marquee-content');
        marquee.appendChild(clone);
      });

      // Now we have: [first half] + [identical second half]

      // Calculate speed
      var speed = parseInt(marquee.getAttribute('data-speed')) || 40;
      var pixelsPerSecond = 1000 / speed;

      // Direction: 'right' means text scrolls right (reverse)
      var isReverse = marquee.getAttribute('data-direction') === 'right';

      // Hover pause
      var paused = false;
      marquee.addEventListener('mouseenter', function() { paused = true; });
      marquee.addEventListener('mouseleave', function() { paused = false; });

      // JS-driven animation loop (immune to iOS scroll resets)
      var offset = 0;
      var lastTime = performance.now();

      function animate(now) {
        if (!paused) {
          var delta = now - lastTime;
          var movement = delta * pixelsPerSecond / 1000;

          if (isReverse) {
            offset -= movement;
            if (offset < 0) offset += firstHalfWidth;
          } else {
            offset += movement;
            if (offset >= firstHalfWidth) offset -= firstHalfWidth;
          }

          marquee.style.transform = 'translateX(' + (-offset) + 'px)';
        }
        lastTime = now;
        marquee._marqueeRaf = requestAnimationFrame(animate);
      }

      marquee._marqueeRaf = requestAnimationFrame(animate);
    });
  }

  function initAllMarquees(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.announcement-bar[data-marquee-enabled="true"]');
    containers.forEach(function(container) {
      initMarquee(container);
    });
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    initAllMarquees(document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() { initAllMarquees(document); }, 50);
  }

  // Reinitialize on resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() { initAllMarquees(document); }, 200);
  });

  // Reinitialize on Shopify section events
  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(function() { initAllMarquees(e.target); }, 100);
  });

  // Expose globally
  window.initAnnouncementMarquee = initMarquee;
  window.initAllAnnouncementMarquees = initAllMarquees;
})();

/// Hero Logo Animation (Image Banner to Header) ///
(function() {
  var heroLogoState = null;

  function initHeroLogoAnimation() {
    // Clean up previous state
    if (heroLogoState) {
      if (heroLogoState.scrollHandler) {
        window.removeEventListener('scroll', heroLogoState.scrollHandler);
      }
      if (heroLogoState.resizeHandler) {
        window.removeEventListener('resize', heroLogoState.resizeHandler);
      }
    }

    var header = document.querySelector('.header-section');

    // Helper to show header logo when hero animation is not active
    function showHeaderLogo() {
      if (header) {
        header.classList.add('no-hero-animation');
      }
    }

    var banner = document.querySelector('[data-hero-logo-banner="true"]');
    if (!banner) {
      showHeaderLogo();
      return;
    }

    var heroLogo = banner.querySelector('.hero-logo');
    var heroContainer = banner.querySelector('.hero-logo-container');

    if (!header || !heroLogo || !heroContainer) {
      showHeaderLogo();
      return;
    }

    // Check conditions: overlay mode + fixed/sticky
    var isOverlayMode = header.getAttribute('data-overlay-mode') === 'true';
    var headerBehavior = header.getAttribute('data-header-behavior');
    var isFixedOrSticky = headerBehavior === 'fixed' || headerBehavior === 'sticky';

    // Get overlay logo from header (either overlay-specific or any logo)
    var headerOverlayLogo = header.querySelector('.header-el--overlay.header-logo') ||
                            header.querySelector('.logo-wrapper .header-logo');

    // All conditions must be met
    if (!isOverlayMode || !isFixedOrSticky || !headerOverlayLogo) {
      heroContainer.style.display = 'none';
      showHeaderLogo();
      return;
    }

    // Set hero logo source from header overlay logo
    heroLogo.src = headerOverlayLogo.src;

    // Check if banner is first section after header-group
    var mainContent = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
    var firstSection = mainContent.querySelector('.shopify-section');
    var bannerSection = banner.closest('.shopify-section');

    if (firstSection !== bannerSection) {
      heroContainer.style.display = 'none';
      showHeaderLogo();
      return;
    }

    // Check initial scroll position - if already scrolled, skip to header state
    var initialScrollY = window.scrollY || window.pageYOffset;
    var bannerHeight = banner.offsetHeight;
    var isAlreadyScrolled = initialScrollY > 5;

    // Setup initial state
    heroContainer.style.display = '';
    header.classList.add('hero-logo-active');

    // If already scrolled past threshold, immediately show header logo (no animation)
    if (isAlreadyScrolled) {
      header.classList.add('show-header-logo');
      heroContainer.style.opacity = '0';
      heroContainer.style.visibility = 'hidden';
    } else {
      header.classList.add('in-banner-area');
      // Show hero logo after layout is stable (CSS variables are set)
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          heroContainer.style.opacity = '1';
        });
      });
    }

    var headerLogoWrapper = header.querySelector('.logo-wrapper');
    var scrollThreshold = 1; // Trigger animation immediately on scroll

    // Animation state - start as 'in-header' if already scrolled
    var state = isAlreadyScrolled ? 'in-header' : 'idle';
    var animationTimeout = null;

    // Get position setting (top or center)
    var logoPosition = banner.getAttribute('data-hero-logo-position') || 'center';

    // Store original hero logo size (in pixels, computed from vw)
    var originalLogoWidth = heroLogo.offsetWidth;

    function getHeaderLogoPosition() {
      if (!headerLogoWrapper) return { x: 0, y: 0 };
      var logoRect = headerLogoWrapper.getBoundingClientRect();

      // Use absolute viewport coordinates (header-group is now always fixed)
      return {
        x: logoRect.left + logoRect.width / 2,
        y: logoRect.top + logoRect.height / 2
      };
    }

    function getInitialPosition() {
      var bannerRect = banner.getBoundingClientRect();
      var x = bannerRect.left + bannerRect.width / 2;
      var y;

      if (logoPosition === 'top') {
        // Top position: logo top edge at header-group-height + padding
        // CSS uses transform: translate(-50%, 0) so top value is logo's top edge
        var headerGroupHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')) || 60;
        var isMobile = window.innerWidth < 750;
        var padding = 10;
        // Return center point for animation (add half logo height)
        var logoHeight = heroLogo.offsetHeight || 100;
        y = bannerRect.top + headerGroupHeight + padding + logoHeight / 2;
      } else {
        // Center position: logo center at banner center
        y = bannerRect.top + bannerRect.height / 2;
      }

      return { x: x, y: y };
    }

    // Immediately reset to initial state without animation
    function immediateReset() {
      if (animationTimeout) {
        clearTimeout(animationTimeout);
        animationTimeout = null;
      }

      // Remove classes
      heroContainer.classList.remove('in-header');
      header.classList.remove('show-header-logo');

      function doReset() {
        // Remove animation class (disables transitions via CSS :not selector)
        heroContainer.classList.remove('animate-to-header');

        // Small delay to let browser apply transition:none
        requestAnimationFrame(function() {
          // First, switch to absolute positioning with CSS-equivalent values
          // This prevents jump when removing fixed positioning
          var headerGroupHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')) || 60;

          if (logoPosition === 'top') {
            heroContainer.style.position = 'absolute';
            heroContainer.style.top = (headerGroupHeight + 10) + 'px';
            heroContainer.style.left = '50%';
            heroContainer.style.transform = 'translate(-50%, 0)';
          } else {
            heroContainer.style.position = 'absolute';
            heroContainer.style.top = '50%';
            heroContainer.style.left = '50%';
            heroContainer.style.transform = 'translate(-50%, -50%)';
          }
          heroContainer.style.paddingTop = '';
          heroLogo.style.width = '';

          // Now remove inline styles - CSS values match so no jump
          requestAnimationFrame(function() {
            heroContainer.style.position = '';
            heroContainer.style.top = '';
            heroContainer.style.left = '';
            heroContainer.style.transform = '';

            state = 'idle';

            // Update originalLogoWidth for next animation cycle
            originalLogoWidth = heroLogo.offsetWidth;
          });
        });
      }

      var scrollY = window.scrollY || window.pageYOffset;

      // Only fully remove styles when scroll is at 0
      if (scrollY === 0) {
        doReset();
      } else {
        // Wait for scroll to reach 0
        state = 'waiting-for-top';
        requestAnimationFrame(function checkScroll() {
          var currentScroll = window.scrollY || window.pageYOffset;
          if (currentScroll === 0) {
            doReset();
          } else if (state === 'waiting-for-top') {
            requestAnimationFrame(checkScroll);
          }
        });
      }
    }

    function triggerAnimation() {
      if (state !== 'idle') return;
      state = 'animating-to-header';

      // Get current logo visual center
      var logoRect = heroLogo.getBoundingClientRect();
      var currentCenterX = logoRect.left + logoRect.width / 2;
      var currentCenterY = logoRect.top + logoRect.height / 2;
      var currentLogoWidth = logoRect.width || originalLogoWidth;

      // Get target position
      var headerPos = getHeaderLogoPosition();
      var headerLogoSize = headerOverlayLogo.offsetWidth || 100;

      // Fix position at current visual center
      heroContainer.style.position = 'fixed';
      heroContainer.style.top = currentCenterY + 'px';
      heroContainer.style.left = currentCenterX + 'px';
      heroContainer.style.transform = 'translate(-50%, -50%)';
      heroContainer.style.paddingTop = '0';
      heroLogo.style.width = currentLogoWidth + 'px';

      // Force reflow
      heroContainer.offsetHeight;

      // Add animation class
      heroContainer.classList.add('animate-to-header');

      // Animate to header position
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (state !== 'animating-to-header') return;
          heroContainer.style.top = headerPos.y + 'px';
          heroContainer.style.left = headerPos.x + 'px';
          heroLogo.style.width = headerLogoSize + 'px';
        });
      });

      // After animation completes
      animationTimeout = setTimeout(function() {
        if (state !== 'animating-to-header') return;
        state = 'in-header';
        heroContainer.classList.add('in-header');
        header.classList.add('show-header-logo');
      }, 700);
    }

    // Force complete animation immediately (for fast scroll)
    function forceCompleteToHeader() {
      if (state !== 'animating-to-header') return;

      // Clear pending timeout
      if (animationTimeout) {
        clearTimeout(animationTimeout);
        animationTimeout = null;
      }

      // Get header position and snap logo there instantly
      var headerPos = getHeaderLogoPosition();
      var headerLogoSize = headerOverlayLogo.offsetWidth || 100;

      // Disable transitions temporarily
      heroContainer.style.transition = 'none';
      heroLogo.style.transition = 'none';

      // Snap to header position
      heroContainer.style.top = headerPos.y + 'px';
      heroContainer.style.left = headerPos.x + 'px';
      heroLogo.style.width = headerLogoSize + 'px';

      // Force reflow
      heroContainer.offsetHeight;

      // Restore transitions
      heroContainer.style.transition = '';
      heroLogo.style.transition = '';

      // Complete the state
      state = 'in-header';
      heroContainer.classList.add('in-header');
      header.classList.add('show-header-logo');
    }

    function resetAnimation() {
      if (state === 'idle' || state === 'animating-to-banner') return;

      // Clear any pending timeout
      if (animationTimeout) {
        clearTimeout(animationTimeout);
        animationTimeout = null;
      }

      var wasInHeader = state === 'in-header';
      var wasAnimatingToHeader = state === 'animating-to-header';
      state = 'animating-to-banner';

      // Show hero logo, hide header logo
      heroContainer.classList.remove('in-header');
      header.classList.remove('show-header-logo');

      // If hero container was hidden (page loaded scrolled), need to set up for animation
      if (wasInHeader && heroContainer.style.visibility === 'hidden') {
        // Position hero logo at header location first
        var headerPos = getHeaderLogoPosition();
        var headerLogoSize = headerOverlayLogo.offsetWidth || 100;

        heroContainer.style.position = 'fixed';
        heroContainer.style.top = headerPos.y + 'px';
        heroContainer.style.left = headerPos.x + 'px';
        heroContainer.style.transform = 'translate(-50%, -50%)';
        heroContainer.style.paddingTop = '0';
        heroLogo.style.width = headerLogoSize + 'px';

        // Make visible
        heroContainer.style.opacity = '1';
        heroContainer.style.visibility = 'visible';

        // Force reflow before adding animation class
        heroContainer.offsetHeight;
      }

      // Make sure we have animation class for transitions
      if (!heroContainer.classList.contains('animate-to-header')) {
        heroContainer.classList.add('animate-to-header');
      }

      // Calculate target position (using center-based positioning during animation)
      var bannerRect = banner.getBoundingClientRect();
      var targetX = bannerRect.left + bannerRect.width / 2;
      var targetY;

      // Calculate logo height based on original width and aspect ratio
      var aspectRatio = heroLogo.naturalHeight / heroLogo.naturalWidth || 1;
      var logoHeight = originalLogoWidth * aspectRatio;

      if (logoPosition === 'top') {
        // CSS uses: top = header-group-height + 10px (relative to banner), transform = translate(-50%, 0)
        // For fixed positioning, we need viewport coordinates
        // Logo top edge should be at: bannerRect.top + header-group-height + 10
        // Logo center should be at: bannerRect.top + header-group-height + 10 + logoHeight/2
        var headerGroupHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')) || 60;
        var padding = 10;
        targetY = bannerRect.top + headerGroupHeight + padding + logoHeight / 2;
      } else {
        // For 'center' position - logo center at banner center
        targetY = bannerRect.top + bannerRect.height / 2;
      }

      // Animate to target center position (keep using translate(-50%, -50%) during animation)
      heroContainer.style.top = targetY + 'px';
      heroContainer.style.left = targetX + 'px';
      heroLogo.style.width = originalLogoWidth + 'px';

      // After animation completes
      animationTimeout = setTimeout(function() {
        if (state !== 'animating-to-banner') return;
        immediateReset();
      }, 700);
    }

    function updateHeaderState() {
      var scrollY = window.scrollY || window.pageYOffset;
      var bannerHeight = banner.offsetHeight;

      // Check if we're in banner area
      var inBannerArea = scrollY < bannerHeight - 100;

      if (inBannerArea) {
        header.classList.add('in-banner-area');
      } else {
        header.classList.remove('in-banner-area');
        // Force complete animation if scrolled past banner while still animating
        if (state === 'animating-to-header') {
          forceCompleteToHeader();
        }
      }

      // Handle state transitions based on scroll position
      if (scrollY <= 5) {
        // At top - should be in idle state
        if (state === 'animating-to-header' || state === 'in-header') {
          resetAnimation();
        }
        // animating-to-banner and waiting-for-top will resolve themselves
      } else if (scrollY > scrollThreshold) {
        // Scrolled down - should animate to header
        if (state === 'idle') {
          triggerAnimation();
        } else if (state === 'animating-to-banner') {
          // User scrolled down while returning to banner - reverse direction smoothly
          if (animationTimeout) {
            clearTimeout(animationTimeout);
            animationTimeout = null;
          }
          // Don't remove animation class - keep transitions active
          // Just change state and animate to header
          state = 'animating-to-header';

          var headerPos = getHeaderLogoPosition();
          var headerLogoSize = headerOverlayLogo.offsetWidth || 100;

          heroContainer.style.top = headerPos.y + 'px';
          heroContainer.style.left = headerPos.x + 'px';
          heroLogo.style.width = headerLogoSize + 'px';

          animationTimeout = setTimeout(function() {
            if (state !== 'animating-to-header') return;
            state = 'in-header';
            heroContainer.classList.add('in-header');
            header.classList.add('show-header-logo');
          }, 700);
        } else if (state === 'waiting-for-top') {
          // User scrolled down while waiting - go to header
          if (animationTimeout) {
            clearTimeout(animationTimeout);
            animationTimeout = null;
          }
          state = 'idle';
          // Need to re-setup for triggerAnimation
          heroContainer.style.position = '';
          heroContainer.style.top = '';
          heroContainer.style.left = '';
          heroContainer.style.transform = '';
          heroContainer.style.paddingTop = '';
          heroLogo.style.width = '';
          heroContainer.classList.remove('animate-to-header');
          triggerAnimation();
        }
      }
    }

    // Scroll handler with throttling
    var ticking = false;
    function scrollHandler() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateHeaderState();
          ticking = false;
        });
        ticking = true;
      }
    }

    // Resize handler - update position if in header, or update original size if idle
    function resizeHandler() {
      if (state === 'in-header') {
        var headerPos = getHeaderLogoPosition();
        heroContainer.style.top = headerPos.y + 'px';
        heroContainer.style.left = headerPos.x + 'px';
      } else if (state === 'idle') {
        // Update original size when window is resized (vw units change)
        originalLogoWidth = heroLogo.offsetWidth;
      }
    }

    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', resizeHandler);

    // Save state for cleanup
    heroLogoState = {
      scrollHandler: scrollHandler,
      resizeHandler: resizeHandler
    };

    // Initial state check
    updateHeaderState();
  }

  // Initialize after DOM ready with delay for CSS variables to be set
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initHeroLogoAnimation, 100);
    });
  } else {
    setTimeout(initHeroLogoAnimation, 100);
  }

  // Reinit on section load
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-hero-logo-banner]') || e.target.querySelector('.header-section')) {
      setTimeout(initHeroLogoAnimation, 100);
    }
  });

  // Expose globally
  window.initHeroLogoAnimation = initHeroLogoAnimation;
})();

/// Before/After Slider ///
(function() {
  function initBeforeAfter(container) {
    if (!container || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    const slider = container.querySelector('[data-slider]');
    const beforeClip = container.querySelector('[data-before-clip]');
    if (!slider || !beforeClip) return;

    let isDragging = false;
    let hasAnimated = false;

    function setSliderAt(percentage) {
      slider.style.left = percentage + '%';
      beforeClip.style.clipPath = 'inset(0 ' + (100 - percentage) + '% 0 0)';
    }

    function updateSliderPosition(x) {
      const rect = container.getBoundingClientRect();
      let percentage = ((x - rect.left) / rect.width) * 100;
      percentage = Math.max(0, Math.min(100, percentage));
      setSliderAt(percentage);
    }

    function wiggleAnimation() {
      if (hasAnimated) return;
      hasAnimated = true;

      const duration = 1400;
      const amplitude = 4;
      const start = performance.now();

      function animate(time) {
        const elapsed = time - start;
        const progress = Math.min(elapsed / duration, 1);

        // Симметричное движение: центр -> влево -> центр -> вправо -> центр
        const wave = Math.sin(progress * Math.PI * 2);
        const fadeOut = 1 - progress;
        const percentage = 50 + (wave * amplitude * fadeOut);

        setSliderAt(percentage);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setSliderAt(50);
        }
      }

      requestAnimationFrame(animate);
    }

    // Intersection Observer for wiggle animation
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimated) {
          setTimeout(wiggleAnimation, 300);
          observer.disconnect();
        }
      });
    }, { threshold: 0.5 });

    observer.observe(container);

    function onStart(e) {
      isDragging = true;
      hasAnimated = true;
      container.classList.add('is-dragging');
      const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      updateSliderPosition(x);
    }

    function onMove(e) {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      updateSliderPosition(x);
    }

    function onEnd() {
      isDragging = false;
      container.classList.remove('is-dragging');
    }

    slider.addEventListener('mousedown', onStart);
    slider.addEventListener('touchstart', onStart, { passive: true });

    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });

    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);

    container.addEventListener('click', function(e) {
      if (e.target === slider || slider.contains(e.target)) return;
      updateSliderPosition(e.clientX);
    });
  }

  function initAllBeforeAfter() {
    document.querySelectorAll('[data-before-after]').forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBeforeAfter);
  } else {
    initAllBeforeAfter();
  }

  document.addEventListener('shopify:section:load', function(e) {
    const container = e.target.querySelector('[data-before-after]');
    if (container) initBeforeAfter(container);
  });
})();

/// Header Menu (Burger, Submenus, Country Selector) ///
(function() {
  function initHeaderMenu(scope) {
    var root = scope || document;
    var burgerMenu = root.querySelector('.burger-menu');
    var headerMenu = root.querySelector('.header-menu');
    var body = document.body;

    // Burger menu toggle
    if (burgerMenu && headerMenu && !burgerMenu.dataset.headerMenuBound) {
      burgerMenu.dataset.headerMenuBound = 'true';
      burgerMenu.addEventListener('click', function() {
        var isOpen = headerMenu.classList.contains('active');
        headerMenu.classList.toggle('active');
        burgerMenu.classList.toggle('menu-open');
        body.style.overflow = isOpen ? 'inherit' : 'hidden';
      });
    }

    // Submenu toggles (mobile)
    var menuItems = root.querySelectorAll('.header-menu > .menu-item');
    menuItems.forEach(function(item) {
      if (item.dataset.submenuBound) return;
      item.dataset.submenuBound = 'true';

      var link = item.querySelector('.menu-link');
      if (!link) return;

      link.addEventListener('click', function(event) {
        if (item.classList.contains('has-children')) {
          event.preventDefault();
          var active = document.querySelector('.menu-item.active');
          if (active && active !== item) {
            active.classList.remove('active');
            var activeSub = active.querySelector('.submenu');
            if (activeSub) activeSub.style.display = 'none';
          }
          var submenu = item.querySelector('.submenu');
          if (submenu) {
            submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
          }
          item.classList.toggle('active');
        }
      });
    });

    // Close submenus on outside click
    if (!document.body.dataset.submenuOutsideBound) {
      document.body.dataset.submenuOutsideBound = 'true';
      document.addEventListener('click', function(event) {
        if (!event.target.closest('.menu-item')) {
          var submenus = document.querySelectorAll('.submenu');
          submenus.forEach(function(submenu) {
            submenu.style.display = 'none';
          });
          var activeItems = document.querySelectorAll('.menu-item.active');
          activeItems.forEach(function(item) {
            item.classList.remove('active');
          });
        }
      });
    }

    // Country selector (Desktop)
    var countrySelector = root.querySelector('.country-selector');
    if (countrySelector && !countrySelector.dataset.countrySelectorBound) {
      countrySelector.dataset.countrySelectorBound = 'true';
      var countryButton = countrySelector.querySelector('.country-selector__button');
      var countryDropdown = countrySelector.querySelector('.country-selector__dropdown');

      if (countryButton && countryDropdown) {
        countryButton.addEventListener('click', function(e) {
          e.stopPropagation();
          var isOpen = countryDropdown.hidden === false;
          countryDropdown.hidden = isOpen;
          countryButton.setAttribute('aria-expanded', !isOpen);
        });

        document.addEventListener('click', function(event) {
          if (!event.target.closest('.country-selector')) {
            countryDropdown.hidden = true;
            countryButton.setAttribute('aria-expanded', 'false');
          }
        });

        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' && !countryDropdown.hidden) {
            countryDropdown.hidden = true;
            countryButton.setAttribute('aria-expanded', 'false');
            countryButton.focus();
          }
        });
      }
    }

    // Country selector (Mobile)
    var countrySelectorMobile = root.querySelector('.country-selector-mobile');
    if (countrySelectorMobile && !countrySelectorMobile.dataset.countrySelectorBound) {
      countrySelectorMobile.dataset.countrySelectorBound = 'true';
      var mobileButton = countrySelectorMobile.querySelector('.country-selector__button--mobile');
      var mobileDropdown = countrySelectorMobile.querySelector('.country-selector__dropdown--mobile');

      if (mobileButton && mobileDropdown) {
        mobileButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = !mobileDropdown.hidden;

          if (!isOpen) {
            var buttonRect = mobileButton.getBoundingClientRect();
            var spaceBelow = window.innerHeight - buttonRect.bottom;
            var dropdownHeight = 250;

            if (spaceBelow < dropdownHeight) {
              mobileDropdown.classList.add('dropdown--up');
            } else {
              mobileDropdown.classList.remove('dropdown--up');
            }
          }

          mobileDropdown.hidden = isOpen;
          mobileButton.setAttribute('aria-expanded', !isOpen);
        });

        document.addEventListener('click', function(event) {
          if (!event.target.closest('.country-selector-mobile')) {
            mobileDropdown.hidden = true;
            mobileButton.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initHeaderMenu(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.header-section') || e.target.querySelector('.header-menu')) {
      // Reset bound flags
      var burger = e.target.querySelector('.burger-menu');
      if (burger) burger.dataset.headerMenuBound = '';
      var items = e.target.querySelectorAll('.menu-item');
      items.forEach(function(i) { i.dataset.submenuBound = ''; });
      var cs = e.target.querySelector('.country-selector');
      if (cs) cs.dataset.countrySelectorBound = '';
      var csm = e.target.querySelector('.country-selector-mobile');
      if (csm) csm.dataset.countrySelectorBound = '';

      initHeaderMenu(e.target);
    }
  });

  window.initHeaderMenu = initHeaderMenu;
})();

/// Video Banner ///
(function() {
  function initVideoBanner(section) {
    if (!section || section.dataset.videoBannerBound) return;
    section.dataset.videoBannerBound = 'true';

    var playButton = section.querySelector('[data-play-button]');
    var videoWrapper = section.querySelector('[data-video-wrapper]');
    var videoElement = section.querySelector('[data-video-element]');

    if (!playButton) return;

    playButton.addEventListener('click', function() {
      section.classList.add('playing');

      if (videoElement) {
        videoElement.play();
      } else if (videoWrapper) {
        var videoType = videoWrapper.dataset.videoType;
        var videoId = videoWrapper.dataset.videoId;
        var iframeSrc = '';

        if (videoType === 'youtube') {
          iframeSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        } else if (videoType === 'vimeo') {
          iframeSrc = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        }

        if (iframeSrc) {
          var iframe = document.createElement('iframe');
          iframe.className = 'video-banner__iframe';
          iframe.src = iframeSrc;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          videoWrapper.appendChild(iframe);
        }
      }
    });

    if (videoElement) {
      videoElement.addEventListener('ended', function() {
        if (!videoElement.loop) {
          section.classList.remove('playing');
        }
      });

      videoElement.addEventListener('click', function() {
        if (videoElement.paused) {
          videoElement.play();
          section.classList.add('playing');
        } else {
          videoElement.pause();
          section.classList.remove('playing');
        }
      });
    }
  }

  function initAllVideoBanners(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.video-banner');
    sections.forEach(initVideoBanner);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllVideoBanners(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.video-banner');
    if (section) {
      section.dataset.videoBannerBound = '';
      initVideoBanner(section);
    }
  });

  window.initVideoBanner = initVideoBanner;
})();

/// FAQ Accordion ///
(function() {
  function initFaqAccordion(container) {
    if (!container || container.dataset.faqBound) return;
    container.dataset.faqBound = 'true';

    var questions = container.querySelectorAll('.question');
    questions.forEach(function(question) {
      question.addEventListener('click', function() {
        this.classList.toggle('active');
        var answer = this.nextElementSibling;
        if (answer) {
          if (answer.style.maxHeight) {
            answer.style.maxHeight = null;
          } else {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        }
      });
    });
  }

  function initAllFaqAccordions(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.faq-section');
    containers.forEach(initFaqAccordion);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllFaqAccordions(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    var container = e.target.querySelector('.faq-section');
    if (container) {
      container.dataset.faqBound = '';
      initFaqAccordion(container);
    }
  });

  window.initFaqAccordion = initFaqAccordion;
})();

/// Newsletter Success Message ///
(function() {
  function initNewsletter() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;

    var newTitle = document.querySelector('.email__new-title');
    var emailIntro = document.querySelector('.email-banner__form-group');

    if (emailIntro) emailIntro.style.display = 'none';
    if (newTitle) newTitle.style.display = 'block';
  }

  document.addEventListener('DOMContentLoaded', initNewsletter);
  window.addEventListener('load', initNewsletter);
})();

/// Contact Form Validation ///
(function() {
  function initContactForm(form) {
    if (!form || form.dataset.contactFormBound) return;
    form.dataset.contactFormBound = 'true';

    var phoneAlert = form.dataset.phoneAlert || 'Please enter phone number starting with +';
    var sentMessage = form.dataset.sentMessage || 'Message sent!';

    form.addEventListener('submit', function(e) {
      var phoneInput = form.querySelector('#ContactFormPhone');
      if (phoneInput) {
        var phoneNumber = phoneInput.value;
        if (!phoneNumber.startsWith('+')) {
          e.preventDefault();
          alert(phoneAlert);
          return false;
        }
      }

      var messageContainer = document.getElementById('contactFormMessageContainer');
      if (messageContainer) {
        e.preventDefault();
        setTimeout(function() {
          messageContainer.textContent = sentMessage;
          messageContainer.style.color = 'green';
          messageContainer.style.display = 'block';
        }, 500);
      }
    });
  }

  function initAllContactForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.contact-form');
    forms.forEach(initContactForm);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllContactForms(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    var form = e.target.querySelector('.contact-form');
    if (form) {
      form.dataset.contactFormBound = '';
      initContactForm(form);
    }
  });

  window.initContactForm = initContactForm;
})();

/// Music Player ///
(function() {
  function initMusicPlayer() {
    var musicIcon = document.getElementById('music-icon');
    var audioPlayer = document.getElementById('audio-player');

    if (!musicIcon || !audioPlayer) return;
    if (musicIcon.dataset.musicPlayerBound) return;
    musicIcon.dataset.musicPlayerBound = 'true';

    var iconColor = musicIcon.dataset.iconColor || 'currentColor';
    var playButton = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="' + iconColor + '"><path d="M8 5v14l11-7z"/></svg>';
    var pauseButton = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="' + iconColor + '"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 6h2v12h-2zm4 0h2v12h-2z"/></svg>';
    var isAudioPlaying = 'isAudioPlaying';
    var currentAudioTime = 'currentAudioTime';

    function checkMusic() {
      if (audioPlayer.paused) {
        musicIcon.innerHTML = playButton;
      } else {
        musicIcon.innerHTML = pauseButton;
      }
    }

    musicIcon.addEventListener('click', function() {
      if (audioPlayer.paused) {
        audioPlayer.play();
        var savedTime = localStorage.getItem(currentAudioTime);
        if (savedTime) audioPlayer.currentTime = parseFloat(savedTime);
        localStorage.setItem(isAudioPlaying, 'true');
      } else {
        audioPlayer.pause();
        localStorage.setItem(isAudioPlaying, 'false');
      }
      checkMusic();
    });

    function startPlayerIfAudioIsPlaying() {
      if (localStorage.getItem(isAudioPlaying) === 'true') {
        audioPlayer.play().catch(function() {});
        checkMusic();
      }
    }

    window.addEventListener('click', startPlayerIfAudioIsPlaying, { once: true });
    window.addEventListener('touchstart', startPlayerIfAudioIsPlaying, { once: true });

    // Initialize
    if (!localStorage.getItem(isAudioPlaying)) {
      localStorage.setItem(isAudioPlaying, 'true');
    }
    if (localStorage.getItem(isAudioPlaying) === 'true') {
      audioPlayer.play().catch(function() {});
      var savedTime = localStorage.getItem(currentAudioTime);
      if (savedTime) audioPlayer.currentTime = parseFloat(savedTime);
    }
    checkMusic();

    // Save time periodically
    setInterval(function() {
      if (audioPlayer.currentTime !== 0) {
        localStorage.setItem(currentAudioTime, audioPlayer.currentTime);
      }
    }, 500);

    window.addEventListener('beforeunload', function() {
      if (audioPlayer.currentTime !== 0) {
        localStorage.setItem(currentAudioTime, audioPlayer.currentTime);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initMusicPlayer);
  window.initMusicPlayer = initMusicPlayer;
})();

/// Cart Page Quantity ///
(function() {
  function initCartPageQuantity() {
    var cartPage = document.querySelector('.cart-page');
    if (!cartPage) return;

    var wrappers = cartPage.querySelectorAll('.quantity-wrapper');
    if (!wrappers.length) return;

    var currencySymbol = window.currencySymbol || '$';
    var currencyCode = cartPage.dataset.currencyCode || '';
    var cartTotalText = cartPage.dataset.cartTotalText || 'Total';

    function updateButtonStates(wrapper, inventoryQuantity, trackQuantity, allowOversell) {
      var minusButton = wrapper.querySelector('.cart__quantity-btn-minus');
      var plusButton = wrapper.querySelector('.cart__quantity-btn-plus');
      var quantity = parseInt(wrapper.getAttribute('data-quantity'));

      if (minusButton) {
        if (quantity <= 1) {
          minusButton.classList.add('disabled');
          minusButton.disabled = true;
        } else {
          minusButton.classList.remove('disabled');
          minusButton.disabled = false;
        }
      }

      if (plusButton) {
        if (trackQuantity === 'false' || allowOversell === 'true') {
          plusButton.classList.remove('disabled');
          plusButton.disabled = false;
        } else {
          if (quantity >= inventoryQuantity) {
            plusButton.classList.add('disabled');
            plusButton.disabled = true;
          } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
          }
        }
      }
    }

    function updateCartQuantity(wrapper, quantity, inventoryQuantity, trackQuantity, allowOversell) {
      var key = wrapper.getAttribute('data-key');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Error updating cart');
        return response.json();
      })
      .then(function(cart) {
        wrapper.setAttribute('data-quantity', quantity);
        var qtyEl = document.getElementById('quantity-' + key);
        if (qtyEl) qtyEl.textContent = quantity;

        updateButtonStates(wrapper, inventoryQuantity, trackQuantity, allowOversell);
        updateCartTotal(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function(error) {
        console.error('Error:', error);
      });
    }

    function updateCartTotal(cart) {
      var totalElement = document.querySelector('.cart__total');
      if (totalElement) {
        var formattedTotal = currencySymbol + (cart.total_price / 100).toFixed(2) + ' ' + currencyCode;
        totalElement.textContent = cartTotalText + ': ' + formattedTotal;
      }
    }

    function updateCartCount(cartItemCount) {
      var cartCountElement = document.getElementById('CartCount');
      if (cartCountElement) {
        cartCountElement.textContent = cartItemCount;
      }
    }

    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.cartQtyBound) return;
      wrapper.dataset.cartQtyBound = 'true';

      var inventoryQuantity = parseInt(wrapper.getAttribute('data-inventory'));
      var trackQuantity = wrapper.getAttribute('data-track-quantity');
      var allowOversell = wrapper.getAttribute('data-allow-oversell');

      updateButtonStates(wrapper, inventoryQuantity, trackQuantity, allowOversell);

      var minusBtn = wrapper.querySelector('.cart__quantity-btn-minus');
      var plusBtn = wrapper.querySelector('.cart__quantity-btn-plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          var quantity = parseInt(wrapper.getAttribute('data-quantity'));
          if (quantity > 1) {
            quantity--;
            updateCartQuantity(wrapper, quantity, inventoryQuantity, trackQuantity, allowOversell);
          }
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          var quantity = parseInt(wrapper.getAttribute('data-quantity'));
          if (trackQuantity === 'false' || allowOversell === 'true' || quantity < inventoryQuantity) {
            quantity++;
            updateCartQuantity(wrapper, quantity, inventoryQuantity, trackQuantity, allowOversell);
          }
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initCartPageQuantity);
  window.initCartPageQuantity = initCartPageQuantity;
})();

/// Customer Login (Recover Password Toggle) ///
(function() {
  function initCustomerLogin() {
    var recoverForm = document.getElementById('recover-password');
    var customerForm = document.getElementById('customer');
    if (!recoverForm || !customerForm) return;

    window.showRecoverPasswordForm = function() {
      recoverForm.style.display = 'flex';
      customerForm.style.display = 'none';
    };

    window.hideRecoverPasswordForm = function() {
      recoverForm.style.display = 'none';
      customerForm.style.display = 'flex';
    };

    if (window.location.hash === '#recover') {
      window.showRecoverPasswordForm();
    }
  }

  document.addEventListener('DOMContentLoaded', initCustomerLogin);
})();

/// Customer Addresses ///
(function() {
  function initCustomerAddresses() {
    var actionLink = document.querySelector('#action a');
    var addAddressForm = document.querySelector('#add_address');

    if (actionLink && addAddressForm) {
      actionLink.addEventListener('click', function(event) {
        event.preventDefault();
        if (addAddressForm.style.display === 'none') {
          addAddressForm.style.display = 'block';
        } else {
          addAddressForm.style.display = 'none';
        }
      });
    }

    var editLinks = document.querySelectorAll('.action_edit a');
    editLinks.forEach(function(editLink) {
      editLink.addEventListener('click', function(event) {
        event.preventDefault();
        var addressId = this.dataset.addressId;
        var editForm = document.querySelector('#edit_address_' + addressId);
        var viewAddress = document.querySelector('#view_address_' + addressId);

        if (editForm && viewAddress) {
          if (editForm.style.display === 'none') {
            editForm.style.display = 'block';
            viewAddress.style.display = 'none';
          } else {
            editForm.style.display = 'none';
            viewAddress.style.display = 'block';
          }
        }
      });
    });

    // Global function for delete confirmation
    window.ShopifyCustomerAddress = {
      destroy: function(id, confirmMsg) {
        var defaultMsg = 'Are you sure you want to delete this address?';
        if (confirm(confirmMsg || defaultMsg)) {
          Shopify.postLink('/account/addresses/' + id, { parameters: { _method: 'delete' } });
        }
      }
    };
  }

  document.addEventListener('DOMContentLoaded', initCustomerAddresses);
})();

/// Featured Product ///
(function() {
  function initFeaturedProduct(section) {
    if (!section || section.dataset.fpBound) return;
    section.dataset.fpBound = 'true';

    // Get data from data attributes
    var dataEl = section.querySelector('[data-fp-data]');
    if (!dataEl) return;

    var variants, product;
    try {
      variants = JSON.parse(dataEl.dataset.fpVariants || '[]');
      product = JSON.parse(dataEl.dataset.fpProduct || '{}');
    } catch (e) {
      console.error('Featured Product: Invalid JSON data');
      return;
    }

    if (!variants.length) return;

    var variantInput = section.querySelector('[data-fp-variant-id]');
    var priceEl = section.querySelector('[data-fp-price-current]');
    var compareEl = section.querySelector('[data-fp-price-compare]');
    var addBtn = section.querySelector('[data-fp-add-btn]');
    var optionBtns = section.querySelectorAll('[data-fp-option]');
    var imageEl = section.querySelector('[data-fp-image]');
    var form = section.querySelector('[data-fp-form]');

    var selectedOptions = {};
    var strings = {
      addToCart: dataEl.dataset.fpAddToCart || 'Add to Cart',
      soldOut: dataEl.dataset.fpSoldOut || 'Sold Out'
    };
    var currencySymbol = dataEl.dataset.fpCurrency || '$';

    // Initialize with first available variant
    var firstAvailableVariant = variants.find(function(v) { return v.available; }) || variants[0];

    if (firstAvailableVariant) {
      firstAvailableVariant.options.forEach(function(optValue, index) {
        selectedOptions[index + 1] = optValue;
      });
    }

    function formatMoney(cents) {
      return currencySymbol + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i + 1];
        });
      });
    }

    function updateOptionsAvailability() {
      var allSoldOut = !variants.some(function(v) { return v.available; });

      if (allSoldOut) {
        optionBtns.forEach(function(btn) {
          btn.classList.add('disabled');
        });
        return;
      }

      optionBtns.forEach(function(btn) {
        var optionPos = parseInt(btn.dataset.fpOption);
        var value = btn.dataset.fpValue;

        var isAvailable = variants.some(function(variant) {
          var matchesOthers = true;
          Object.keys(selectedOptions).forEach(function(pos) {
            if (parseInt(pos) !== optionPos) {
              if (variant.options[parseInt(pos) - 1] !== selectedOptions[pos]) {
                matchesOthers = false;
              }
            }
          });
          return matchesOthers && variant.available && variant.options[optionPos - 1] === value;
        });

        if (isAvailable) {
          btn.classList.remove('disabled');
        } else {
          btn.classList.add('disabled');
        }
      });
    }

    function updateActiveStates() {
      optionBtns.forEach(function(btn) {
        var optionPos = parseInt(btn.dataset.fpOption);
        var value = btn.dataset.fpValue;
        if (selectedOptions[optionPos] === value) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    function updateUI(variant) {
      if (variantInput && variant) {
        variantInput.value = variant.id;
      }

      if (priceEl) {
        if (variant) {
          priceEl.textContent = formatMoney(variant.price);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.classList.add('product-price__current--sale');
          } else {
            priceEl.classList.remove('product-price__current--sale');
          }
        }
      }

      if (compareEl) {
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.classList.remove('product-price__compare--hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('product-price__compare--hidden');
        }
      }

      if (addBtn) {
        if (variant && variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = strings.addToCart + ' — ' + formatMoney(variant.price);
        } else {
          addBtn.disabled = true;
          addBtn.textContent = strings.soldOut;
        }
      }

      if (imageEl && variant && variant.featured_image) {
        imageEl.src = variant.featured_image.src;
        imageEl.alt = variant.featured_image.alt || product.title;
      }

      // Update quantity wrapper data attrs for inventory limits
      var fpWrapper = section.querySelector('.quantity-wrapper-product');
      if (fpWrapper && variant) {
        fpWrapper.dataset.variantId = variant.id;
        fpWrapper.dataset.inventoryQuantity = variant.inventory_quantity || 0;
        fpWrapper.dataset.inventoryManagement = variant.inventory_management || '';
        fpWrapper.dataset.inventoryPolicy = variant.inventory_policy || 'deny';
        // Reset qty to 1 on variant change
        var fpQtyReset = fpWrapper.querySelector('.qty-value');
        if (fpQtyReset) fpQtyReset.value = 1;
        if (window.updateAllQuantityLimits) window.updateAllQuantityLimits();
      }
    }

    // Option button clicks
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optionPos = parseInt(btn.dataset.fpOption);
        var value = btn.dataset.fpValue;

        selectedOptions[optionPos] = value;

        updateActiveStates();
        updateOptionsAvailability();

        var variant = findVariant();
        updateUI(variant);
      });
    });

    // Form submission
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (!addBtn || addBtn.disabled) return;

        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;

        var fpQtyInput = form.querySelector('input[name="quantity"]');
        var fpQuantity = fpQtyInput ? parseInt(fpQtyInput.value, 10) || 1 : 1;

        var originalHTML = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.innerHTML = '<span class="btn-loading-dots"><span></span><span></span><span></span></span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: fpQuantity })
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Error adding to cart');
          return response.json();
        })
        .then(function() {
          return fetch('/cart.js');
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          addBtn.innerHTML = originalHTML;
          addBtn.disabled = false;

          // Reset quantity selector to 1
          if (fpQtyInput) {
            fpQtyInput.value = 1;
            var fpMinusBtn = form.querySelector('.qty-btn-minus');
            if (fpMinusBtn) { fpMinusBtn.classList.add('disabled'); fpMinusBtn.disabled = true; }
          }

          // Refresh cart cache and update quantity limits for all sections
          if (window.fetchCartItems) {
            window.fetchCartItems(function() {
              if (window.updateAllQuantityLimits) window.updateAllQuantityLimits();
            });
          }

          var cartCountEl = document.getElementById('CartCount');
          if (cartCountEl) cartCountEl.textContent = cart.item_count;

          var cartDrawer = document.getElementById('CartDrawer');
          var cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
          var cartType = window.cartType || (cartDrawer ? 'drawer' : 'page');

          if (cartType === 'drawer' && cartDrawer && cartDrawerOverlay) {
            cartDrawer.classList.add('open');
            cartDrawer.style.right = '0';
            cartDrawer.style.opacity = '1';
            cartDrawer.style.visibility = 'visible';
            cartDrawer.style.display = 'flex';
            cartDrawerOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';

            fetch('/cart?view=cart-drawer')
              .then(function(res) { return res.text(); })
              .then(function(html) {
                var cartDrawerContent = document.getElementById('CartDrawerContent');
                if (cartDrawerContent) {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newContent = doc.getElementById('CartDrawerContent');
                  if (newContent) {
                    cartDrawerContent.innerHTML = newContent.innerHTML;
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                  }
                }
              });
          } else if (cartType === 'page') {
            window.location.href = '/cart';
          }
        })
        .catch(function(error) {
          console.error('Add to cart error:', error);
          addBtn.innerHTML = originalHTML;
          addBtn.disabled = false;
        });
      });
    }

    // Initialize
    updateActiveStates();
    updateOptionsAvailability();
    var initialVariant = findVariant();
    if (initialVariant) {
      updateUI(initialVariant);
    }
  }

  // Featured Product Accordion (separate from variant logic)
  function initFpAccordion(section) {
    if (!section) return;

    var accordions = section.querySelectorAll('.fp-accordion-item');
    if (!accordions.length) return;

    if (accordions.length === 1) {
      accordions[0].classList.add('only-accordion');
    } else if (accordions.length > 1) {
      accordions[0].classList.add('first-accordion');
      accordions[accordions.length - 1].classList.add('last-accordion');
    }

    accordions.forEach(function(accordion) {
      var toggle = accordion.querySelector('.accordion-toggle');
      var content = accordion.querySelector('.accordion-content');
      if (!toggle || !content) return;
      if (toggle.dataset.fpAccBound) return;
      toggle.dataset.fpAccBound = 'true';

      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        // Close all other accordions
        accordions.forEach(function(acc) {
          var otherToggle = acc.querySelector('.accordion-toggle');
          var otherContent = acc.querySelector('.accordion-content');
          if (otherToggle && otherContent) {
            otherToggle.setAttribute('aria-expanded', 'false');
            otherContent.style.maxHeight = null;
          }
        });

        // Toggle current
        if (!isOpen) {
          toggle.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  function initAllFeaturedProducts(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-fp-section]');
    sections.forEach(function(section) {
      initFeaturedProduct(section);
      initFpAccordion(section);
    });
    if (window.initProductQuantity) window.initProductQuantity();
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllFeaturedProducts(document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() { initAllFeaturedProducts(document); }, 50);
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('[data-fp-section]');
    if (section) {
      section.dataset.fpBound = '';
      var toggles = section.querySelectorAll('.accordion-toggle');
      toggles.forEach(function(t) { t.dataset.fpAccBound = ''; });
      var qtyWrappers = section.querySelectorAll('.quantity-wrapper-product');
      qtyWrappers.forEach(function(w) { w.dataset.qtyBound = ''; });
      initFeaturedProduct(section);
      initFpAccordion(section);
      if (window.initProductQuantity) window.initProductQuantity();
    }
  });

  window.initFeaturedProduct = initFeaturedProduct;
  window.initFpAccordion = initFpAccordion;
})();
